<template>
    <div class="room">
        <div class="room_container">
            <div class="">
                <div class="back_btn" @click="$router.go(-1)"><img src="../assets/images/back_btn.svg" alt="戻るボタン"></div>
            </div>
            <div class="selected_room" v-if="room_loaded">
                <RoomView
                        :room_info="selected_room_info"
                        ref="room_view"
                        class="room_card"
                />
                <RoomViewMenu class="menu" v-if="!is_sp" :photo_data="selected_room_info"/>
            </div>
            <RoomViewMenu class="menu" v-if="is_sp" :photo_data="selected_room_info"/>
            <div class="relational_pictures" v-if="relational_tag_list">
                <RoomCardList :search_conditions="relational_tag_list" :or_search="true"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import RoomView from '../components/RoomView'
    import RoomViewMenu from '../components/RoomViewMenu'
    import RoomCardList from '../components/RoomCardList'
    import Ajax from '../assets/js/Ajax'

    export default {
        name: "Room",
        components: { RoomView, RoomCardList, RoomViewMenu },
        data: () => ({
            room_loaded: false
        }),
        computed: {
            ...mapState(["is_sp"]),
            ...mapState('search', ["selected_room_info"]),
            relational_tag_list: _this => {
                if ( !_this.room_loaded || !_this.selected_room_info ) return null;
                return _this.selected_room_info.tags;
            }
        },
        async mounted() {
            this.init();
        },
        async beforeRouteUpdate(to, from, next) {
            next();
            await this.init();
            await this.$nextTick();
            this.$refs.room_view.init();
        },
        methods: {
            ...mapMutations('search', ["setSelectedRoomInfo"]),
            async init() {
                await this.$nextTick();
                const id_param = this.$route.params.id;
                if ( !/^\d+$/.test(id_param) ) return await this.$router.push('/404');

                const room_id = id_param;
                if ( !this.selected_room_info || this.selected_room_info.photo_id !== room_id ) {
                    const room_info = await Ajax.getRoomInfo(room_id);
                    if ( !room_info ) return await this.$router.push('/404');
                    this.setSelectedRoomInfo(room_info);
                }
                this.room_loaded = true;
            }
        }
    }
</script>

<style scoped lang="scss">
    .room{
        background-color: #F2F2F2;
        padding: 30px 0 300px;

        .room_container{
            position: relative;
            max-width: 1075px;
            margin: auto;
            padding: 0 2rem;
            .selected_room{
                padding: 0 9px;
                margin-bottom: 50px;
                display: flex;
                .room_card{
                    width: 60%;
                    max-width: 650px;
                    margin-right: 70px;
                }
                .menu{
                    margin-top: 80px;
                    flex-grow: 1;
                }
            }
            .back_btn {
                position: absolute;
                top: 0;
                left: -50px;
            }
        }
    }

    @media screen and (max-width:639px) {
        .room{
            .room_container{
                max-width: 100%;
                margin: auto;
                padding: 0;
                /*padding: 0 2rem;*/
                .selected_room{
                    padding: 0 35px;
                    margin: 80px auto 50px;
                    display: flex;
                    .room_card{
                        width: 100%;
                        max-width: 100%;
                        margin-right: 0;
                    }
                    .menu{
                        margin-top: 80px;
                        flex-grow: 1;
                    }
                }
                .back_btn {
                    width: 10px;
                    top: 0;
                    left: 10px;
                }
            }
        }
    }
</style>
